import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, FormResetPassword, Page } from "components";
import { useApp, useTheme } from "contexts";
import { Helpers } from "utils";
import { useUser } from "hooks";

type Props = {};

export const ResetPassword = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  const { user } = useUser();

  if (!user) return <Page.Loader />;

  return (
    <Box pt={theme.spacing.xl}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box>
                <Stack spacing={theme.spacing.sm}>
                  <Common.Image src={Helpers.getImage("homepage_banner.png")} />
                  <Box
                    sx={{
                      border: 1,
                      overflow: "hidden",
                      mt: theme.spacing.md,
                      px: theme.spacing.lg,
                      pt: theme.spacing.lg,
                      pb: theme.spacing.xxl,
                      borderRadius: theme.border.radius,
                      borderColor: theme.color.primary.accent,
                    }}
                  >
                    <Stack spacing={theme.spacing.sm}>
                      <Stack spacing={theme.spacing.md}>
                        <Custom.Typography
                          size={theme.font.lg}
                          weight={theme.font.bold}
                        >
                          {t.page.reset_password.header}
                        </Custom.Typography>
                        <Custom.Typography
                          size={theme.font.sm}
                          weight={theme.font.bold}
                        >
                          {t.page.reset_password.subheader}
                        </Custom.Typography>
                      </Stack>
                      <FormResetPassword.Form id={user._id} />
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ display: { sm: "none", md: "unset" } }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
